import React, { useEffect, useState } from "react";
import CallIcon from "../../../images/CallIconForCallbacks2.svg";
import CrossIcon from "../../../images/CrossButtonForCallbacks.svg";

import { fetchCallbackList, fetchCallbackLogs } from "../../../services/api/sponsors";
import CallbackPanel from "./CallBackPanel";

const CallbackFloating = () => {
  const [open, setOpen] = useState(false);
  const [callbackList, setCallbackList] = useState([]);
  const [callbackCount, setCallbackCount] = useState(0);
  const [callbackLogs, setCallbackLogs] = useState([]);
  const [callbackLogsCount, setCallbackLogsCount] = useState(0);

  const getActiveCallbackRequests = () => {
    return fetchCallbackList()
      .then((response) => {
        const activeCallbacks = (response?.data || []).filter(
          (callback) => callback.status === "SCHEDULED"
        );

        setCallbackList(activeCallbacks);
        setCallbackCount(activeCallbacks.length);
      })
      .catch(() => {
        setCallbackList([]);
        setCallbackCount(0);
      });
  };

  const getActiveCallbackLogs = () => {
    return fetchCallbackLogs()
      .then((response) => {
        const data = response.data

        setCallbackLogs(data);
        setCallbackLogsCount(data.length);
      })
      .catch(() => {
        setCallbackLogs([]);
        setCallbackLogsCount(0);
      });
  };

  // initial load + polling
  useEffect(() => {
    getActiveCallbackRequests();
    getActiveCallbackLogs()

    const interval = setInterval(() => {
      getActiveCallbackRequests();
    }, 30000); // 30 sec polling

    return () => clearInterval(interval);
  }, []);

  return (
    <>
      {open && (
        <CallbackPanel
          callbacks={callbackList}
          logs={callbackLogs}
          onClose={() => setOpen(false)}
          getActiveCallbackRequests={getActiveCallbackRequests}
          getActiveCallbackLogs={getActiveCallbackLogs}
        />
      )}

      <div
        onClick={() => setOpen(!open)}
        style={{
          position: "fixed",
          bottom: "24px",
          right: "24px",
          zIndex: 9999,
          cursor: "pointer",
        }}
      >
        <div style={{ position: "relative" }}>
          {(callbackCount > 0 || callbackLogsCount > 0) && <img src={open ? CrossIcon : CallIcon} width={56} height={56} alt="Callbacks" />}

          {callbackCount > 0 && (
            <span
              style={{
                position: "absolute",
                top: "-6px",
                right: "-6px",
                background: "#FF4D4D",
                color: "#FFF",
                borderRadius: "50%",
                padding: "4px 8px",
                fontSize: "12px",
                fontWeight: 600,
                minWidth: "20px",
                textAlign: "center",
              }}
            >
              {callbackCount}
            </span>
          )}
        </div>
      </div>
    </>
  );
};

export default CallbackFloating;
